module.exports = __webpack_public_path__ + "build/img/role_user.4775b41e.png";